import React from "react";
import moment from 'moment';
import {utils_tool, component_tool, framework_tool} from '@/tool';

let {WizModal} = component_tool;
import Editor from './editor';
import BatchEditor from './batchEditor';
import CheckResourcesCount from './checkResourcesCount';

let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'interactLiveResources';

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
let ref;
let ref_;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "第三方使用邮箱",
    name: "searchUserEmail",
    searchItem: {}
  },
  {
    title: "姓氏",
    name: "searchFirstName",
    searchItem: {}
  },
  {
    title: "名",
    name: "searchLastName",
    searchItem: {}
  },
  {
    title: "用户编码",
    name: "searchUserCode",
    searchItem: {}
  },
  {
    title: "第三方用户ID",
    name: "userId",
    tableItem: {
      width: 250,
    },
    searchItem: {}
  },
  {
    title: "第三方使用邮箱",
    name: "userEmail",
    tableItem: {
      width: 350,
    },
  },
  {
    title: "姓氏",
    name: "firstName",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "名",
    name: "lastName",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "用户编码",
    name: "userCode",
    tableItem: {
      width: 150,
    },
  },
  {
    title: "用户付费类型",
    name: "userType",
    dict: [
      {code: 1, codeName: "免费"},
      {code: 2, codeName: "授权"},
      {code: 3, codeName: "预置"},
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: "select"
    },
  },
  {
    title: "帐户使用类型",
    name: "type",
    dict: [
      {code: 0, codeName: "zoom资源帐户"},
      {code: 1, codeName: "远程评估"},
      {code: 2, codeName: "直播课堂/远程认证"},
    ],
    tableItem: {
      width: 150,
    },
    searchItem: {
      type: "select"
    },
  },
  {
    title: "状态",
    name: "status",
    dict: [
      {code: 0, codeName: "禁用"},
      {code: 1, codeName: "激活"},
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: "select"
    },
  },
  {
    title: "资源密码",
    name: "password",
    tableItem: {
      width: 180,
    },
  },
  {
    title: "到期时间",
    name: "expirationTime",
    tableItem: {
      width: 100,
      render: (text, record) => {
        return formatterDate(text)
      }
    },
  },
];

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck: false,
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            return value
          },
          buttonSort: ['batchCreateZoomUserResources','batchClose','batchOpen', 'export', 'batchSyncUserResourcesUserType','checkResourcesCount'],
          buttons: [
            {
              key: 'batchCreateZoomUserResources',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'editorBatchCreateZoomUserResources',
                  modalParams: {
                    title: '批量创建资源账号',
                    style: {minWidth: 700},
                    diy: (e) => {
                      let editorProps = {
                        key: 'editorBatchCreateZoomUserResources_'+self.state.AddTimestamp,
                        ref: r => r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({AddTimestamp: new Date().getTime()})
                        },
                        ...e
                      }
                      return <Editor {...editorProps} />
                    },
                    onCancel: () => {
                      self.setState({AddTimestamp: new Date().getTime()})
                    },
                    footer: false,
                    width: 680
                  },
                }
              }
            },
            {
              key: 'checkResourcesCount',
              custom: true,
              params: {icon: 'into', children: '校验资源账号数', type: "info"},
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'checkResourcesCount',
                  modalParams: {
                    title: '校验资源账号数',
                    style: {minWidth: 700},
                    diy: (e) => {
                      let checkResourcesCountProps = {
                        key: 'checkResourcesCount_'+self.state.AddTimestamp,
                        ref: r => r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({AddTimestamp: new Date().getTime()})
                        },
                        ...e
                      }
                      return <CheckResourcesCount {...checkResourcesCountProps} />
                    },
                    onCancel: () => {
                      self.setState({AddTimestamp: new Date().getTime()})
                    },
                    footer: false,
                    width: 680
                  },
                }
              }
            },
            {
              key: 'batchOpen',
              custom: true,
              params: {icon: "into", children: "批量激活", type: "info"},
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'editorBatchCreateZoomUserResources_'+new Date().getTime(),
                  modalParams: {
                    title: '批量激活',
                    style: {minWidth: 700},
                    diy: (e) => {
                      let editorProps = {
                        operationMode:'all',
                        key: self.state.AddTimestamp,
                        editorSuccess: () => {
                          self.setState({AddTimestamp: new Date().getTime()})
                        },
                        ...e
                      }
                      return <BatchEditor {...editorProps}
                                          ref={(r) => {
                                            ref = r && r.getWrappedInstance();
                                          }}
                      />
                    },
                    onOk: () => {
                      ref._ok();
                    },
                    onCancel: () => {
                      self.setState({AddTimestamp: new Date().getTime()})
                      ref._doInitParams();
                    },
                    footer: false,
                    width: 680
                  },
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  const content = '你确定要激活选中的资源账号吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']) {
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        rows: rows,
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length > 0) {
                  rows.forEach(item => {
                    let {status} = item;
                    if (status != null && status === 1) {
                      disabled = 1;
                    }
                  })
                } else {
                  disabled = 1;
                }
                return {disabled: disabled}
              }
            },
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: "batchSyncUserResourcesUserType",
              custom: true,
              params: {icon: 'reload', children: '批量同步账号付费类型', type: 'reload'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "batchSyncUserResourcesUserType",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: "batchClose",
              custom: true,
              needSelect: true,
              params: {icon: "into", children: "批量禁用", type: "info"},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "updateStatus",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  const content = '你确定要关闭选中的资源账号吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']) {
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        idList: ids,
                        status: 0
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({record, rows}) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length > 0) {
                  rows.forEach(item => {
                    let {status} = item;
                    if (status != null && status === 0) {
                      disabled = 1;
                    }
                  })
                } else {
                  disabled = 1;
                }
                return {disabled: disabled}
              }
            },
          ]
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "Modal",
              children: "Bla bla123 .."
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['open','close','liveList'],
        rowOperateView: [
          {
            key: 'open',
            custom: true,
            params: {icon: "into", children: "激活", type: "info"},
            textFormat: {
              recordKey: 'status',
              dirt: {0: '激活', 1: '修改类型'}
            },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'editorAloneBatchCreateZoomUserResources_'+new Date().getTime(),
                modalParams: {
                  title: '操作',
                  style: {minWidth: 700},
                  diy: (e) => {
                    const {status} = e.record;
                    let statusUpdate = 'open';
                    if (status===1){
                      statusUpdate = 'update'
                    }
                    let editorProps = {
                      operationMode:'alone',
                      operationUpdateMode:statusUpdate,
                      editorSuccess: () => {
                        self.setState({AddTimestamp: new Date().getTime()})
                      },
                      ...e
                    }
                    return <BatchEditor {...editorProps}
                                        ref={(r) => {
                                          ref_ = r && r.getWrappedInstance();
                                        }}
                                        key={'BatchEditor_' + e.record.id +'_'+ self.state.AddTimestamp}
                    />
                  },
                  onOk: () => {
                    ref_._ok();
                  },
                  onCancel: () => {
                    self.setState({AddTimestamp: new Date().getTime()})
                    ref_._doInitParams();
                  },
                  footer: false,
                  width: 680
                },
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '你确定要激活选中的资源账号吗？'
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      record: record,
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              },
            },
          },
          {
            key: "close",
            custom: true,
            params: {children: "禁用"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `你确定要禁用该资源账号吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status:  0,
                      idList: [record['id']]
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let {status} = record;
              return {
                disabled: status !== 1,
                hidden: status !== 1
              };
            }
          },
          {
            key: "liveList",
            custom: true,
            params: {children: "直播列表"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interactLiveResources/liveList"
              }
            }
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          update: true,
          look: true
        }
      }
    }
  };
};

const apis = {
  list: {
    path: `${componentName}/entityByPage`,
    payload: {
      key: `${componentName}@entityByPage`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  batchCreateZoomUserResources: {
    path: `${componentName}/batchCreateZoomUserResources`,
    payload: {
      key: `${componentName}@batchCreateZoomUserResources`,
      apiParams: {}
    }
  },
  batchSyncUserResourcesUserType: {
    path: `${componentName}/batchSyncUserResourcesUserType`,
    payload: {
      key: `${componentName}@batchSyncUserResourcesUserType`,
      apiParams: {}
    }
  },

  updateStatus: {
    path: `${componentName}/updateResourcesState`,
    payload: {
      key: `${componentName}@updateResourcesState`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/entityByList`,
    payload: {
      key: `${componentName}@entityByList`,
      apiParams: {}
    }
  }
}
let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
